<template>
  <div class="el-main" ref="mainViewer">
    <div class="card" v-show="currentCardId == 'basic'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>수신처정보</h2>
          <p>상세주소는 줄이지 말고 입력하세요.</p>
        </div>
        <div class="card-content">
          <div class="edit-form">
            <div class="edit-form-item">
              <div class="item-name">
                郵便番号
                <small v-if="$deviceLib.isOnline">(하이픈 불필요, 주소가 자동 입력됩니다)</small>
                <small v-else>(※ 오프라인으로 주소 자동입력이 불가합니다)</small>
              </div>
              <div class="item-body">
                <el-input class="input-7-digit" placeholder="1001000" title="우편번호" type="tel" ref="postNumber"
                  v-model.lazy="formatData.addressData_postNumber"></el-input>&nbsp;
                <el-button id="send-adtop-pdf" type="success"
                  style="background-color:#0F9934;border-color:#0F9934;padding: 10px;"
                  @click="selectedPostnumber();">자동입력</el-button>
              </div>
              <div class="item-name">시/도/군</div>
              <div class="item-body">
                <el-input autosize placeholder="" title="시/도/군" ref="address1" v-model="formatData.addressData_address1"
                  v-on:blur="formatData.addressData_address1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
              </div>
              <div class="item-name">아파트,건물</div>
              <div class="item-body">
                <el-input autosize placeholder="" title="아파트,건물" ref="address2"
                  v-model="formatData.addressData_address2"
                  v-on:blur="formatData.addressData_address2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">수신회사명</div>
              <div class="item-body">
                <el-input autosize placeholder="회사명" title="회사명" ref="companyName"
                  v-model="formatData.addressData_companyName"></el-input>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">수신담당자명 ※님의 입력은 필요 없습니다.</div>
              <div class="item-body">
                <el-input autosize placeholder="담당자" title="담당자명" ref="staffName"
                  v-model.lazy="formatData.addressData_staffName" style="min-height: 36px;height: 36px;width: 80%;"
                  v-model="formatData.addressData_staffName"></el-input>
                <span style="display: inline;padding: 5px;font-size: 120%;">님</span>
              </div>
            </div>
          </div>

          <div class="edit-form">
            <div class="edit-form-item">
              <p class="card-header2"
                style="border-bottom: none; border-top: 1px solid #f8f8f8; padding: 30px 5px 0 0; margin: 0; color: #004d40; font-weight: bold;">
                발신자정보</p>
              <p class="card-header2" style="border: none; padding: 0; font-size: .75rem;">이력서에 입력한 주소와 다를 경우 입력 해주세요.
              </p>
              <div class="item-name">
                발신자우편번호
                <small v-if="$deviceLib.isOnline">(하이픈불필요)</small>
                <small v-else>(※오프라인으로 주소 자동입력이 불가합니다.)</small>
              </div>
              <div class="item-body">
                <el-input class="input-7-digit" placeholder="1001000" title="우편번호" type="tel" ref="from_postNumber"
                  v-model.lazy="formatData.from_post"></el-input>
              </div>
              <div class="item-name">발신자 시/도/군</div>
              <div class="item-body">
                <el-input autosize placeholder="" title="시/도/군" ref="from_address1" v-model="formatData.from_address1"
                  v-on:blur="formatData.from_address1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
              </div>
              <div class="item-name">아파트/건물</div>
              <div class="item-body">
                <el-input autosize placeholder="" title="아파트/건물" ref="from_address2" v-model="formatData.from_address2"
                  v-on:blur="formatData.from_address2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">발신자명</div>
              <div class="item-body">
                <el-input autosize placeholder="" title="발신자명" ref="from_userName"
                  v-model="formatData.from_name"></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-show="currentCardId == 'letter'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>송장확인</h2>

          <p class="edit_btn">
            ＼한번 작성한 저장데이터는 야기택배로 사용할 수 있어!／<br>
            <a href="/kr/resume/format/letter/edit/letterprofile" class="edit_btn_link"><i class="el-icon-edit"></i>송장을
              편집·신규
              작성</a>
          </p>

          <p>송부 내용에 문제가 없는지 확인 부탁드립니다.</p>
          <span style="color:red;" v-if="formatData.addressData_isLetter == '1'">※미리보기에 빨간색이 보이면 프린트에 문제가 있으니 빨간색이 없어질 수
            있도록 내용을 편집 해주세요.</span>
          <span style="color:red;" v-else-if="formatData.addressData_isLetter == '0'">※송장이 작성되지 않아 전송되는 서류에 첨부되지
            않습니다.</span>

          <div class="edit-form-item" v-if="false">
            <div class="item-body">
              <el-checkbox v-model="formatData.addressData_isLetter">송장첨부</el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-show="currentCardId == 'rirekisho'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>이력서확인</h2>
          <p class="edit_btn">
            ＼한번 작성한 저장데이터는 야기택배로 사용할 수 있어!／<br>
            <a :href="rirekishoUrl" class="edit_btn_link"><i class="el-icon-edit"></i>이력서 편집·신규 작성</a>
          </p>
          <p>이력서 내용에 문제가 없는지 확인 부탁드립니다.</p>
          <span style="color:red;">※미리보기에 빨간색이 보이면 프린트에 문제가 있으니 빨간색이 없어질 수 있도록 내용을 편집 해주세요.</span>

        </div>
        <div class="edit-form-item" style="text-align:center;">
          <h3>이력서 포맷선택 </h3>
          <div class="item-body">
            <el-select v-model="formatData.selFormat" autosize placeholder="선택 해주세요">
              <el-option v-for="item in formatListOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>&nbsp;
            <el-button id="send-adtop-pdf" type="success"
              style="background-color:#0F9934;border-color:#0F9934;;padding: 10px;"
              @click="selectFormat();">선택</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-show="currentCardId == 'keirekisho'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>경력기술서확인</h2>
          <p class="edit_btn">
            ＼한번 작성한 저장데이터는 야기택배로 사용할 수 있어!／<br>
            <a href="/kr/resume/format/shokumukeirekisho/edit/profile" class="edit_btn_link"><i
                class="el-icon-edit"></i>업무 경력서를
              편집·신규 작성하다</a>
          </p>
          <p>경력기술서 내용에 문제가 없는지 확인 부탁드립니다.</p>

          <div class="edit-form-item">
            <div class="item-body">
              <el-checkbox v-model="formatData.addressData_isKeirekisho">경력기술서를 첨부하다</el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-show="currentCardId == 'payment'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>결제</h2>
          <p>야기택배는 신용카드 결제만 가능합니다.<br>
            이용 가능한 카드는 Visa, MasterCard, American Express, JCB, Diners Club, Discover입니다.<br>
            야기택배는 배송까지 1-2일 정도 소요되는 점 양해 부탁드립니다.또한 배송 지역이나 교통 상황에 따라 달라 질 수 있습니다.</p>
          <p class="terms_link"><a href="/kr/resume/quickmailterms" target="_blank">이용약관</a></p>
        </div>
      </div>
      <div class="item-name">
        <h3>구입금액</h3>
      </div>
      <div class="item-body">
        <span style="font-size: 100%;color:red;text-decoration:line-through">9,900원（세금포함）</span>
        <span style="font-size: 120%;color:red;">5,000원（세금포함）</span>
      </div>
      <div class="item-name">
        <h3>カード情報</h3>
      </div>
      <div class="item-body">
        <stripe-element-card ref="stripeCardElememt" :pk="publishableKey" :hidePostalCode="true"
          @token="tokenCreated" />
      </div>
      <span style="font-size: 90%;color:red;">※고객님의 카드정보는 저장되지 않습니다.</span>
      <div class="card-content">
        <div class="edit-form">
          <div class="edit-form-item">
            <div class="item-name">
              <h3 class="h3" style="margin: 30px 0 10px;">수신처 정보<a href="#" @click="$eventHub.$emit('goto_basic')"
                  class="fix"><i class="el-icon-edit"></i>수정</a></h3>
            </div>
            <div class="item-body" style="margin-left:10px;">
              {{ formatData.addressData_postNumber }}<br>
              {{ formatData.addressData_address1 }}<br>
              {{ formatData.addressData_address2 }}<br>
              {{ formatData.addressData_companyName }}<br>
              {{ addressDataStaffName }} 님
              <span v-if="isValidStaffname" style="color:red;">※※불필요한 "~님","~분"의 입력이 없는지 확인해 주세요.</span>
              <span v-if="isNoneStaffname" style="color:red;">※담당자명을 입력하지 않아 '담당자'라고 자동 입력되었습니다.</span>
            </div>
            <div class="item-name">
              <h3 class="h3" style="margin: 30px 0 10px;">差出人情報<a href="#" @click="$eventHub.$emit('goto_basic')"
                  class="fix"><i class="el-icon-edit"></i>수정</a></h3>
            </div>
            <div class="item-body" style="margin-left:10px;">
              {{ formatData.from_post }}<br>
              {{ formatData.from_address1 }}<br>
              {{ formatData.from_address2 }}<br>
              {{ formatData.from_name }}
            </div>
            <div class="item-name">
              <h3 class="h3" style="margin: 30px 0 10px;">전송내용</h3>
              <p>※전송내용을 변경하는 경우는 각페이지에서 확인해 주십시오.</p>
            </div>
            <div class="item-body" style="margin-left:10px;">
              <p v-if="formatData.addressData_isLetter == '1'"><i class="el-icon-document"></i> 송장</p>
              <p><i class="el-icon-document"></i> 이력서（{{ formatData.rirekishoFormatName }}）</p>
              <p v-if="formatData.addressData_isKeirekisho"><i class="el-icon-document"></i> 경력기술서</p>
              <span style="color:red;" v-if="formatData.addressData_isLetter == '0'">※송장이 작성되지 않아 전송되는 서류에 첨부되지
                않습니다.</span>
            </div>
          </div>
        </div>
        <p class="terms_link"><a href="/kr/resume/quickmailterms" target="_blank">이용약관</a></p>
      </div>
    </div>
    <div class="card" v-show="currentCardId == 'complete'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>購入完了</h2>
          <div class="edit-form-item" style="text-align:center;padding: 10px 0 30px; font-weight: bold;">
            구매내역을 메일로 보내드렸으니 확인 부탁드립니다.
          </div>
          <p>야기메일을 구입해 주셔서 감사합니다.
            <br>야기택배는 배송까지 1-2일 정도 소요되는 점 양해 부탁드립니다.또한 배송 지역이나 교통 상황에 따라 달라 질 수 있습니다.
          </p>
        </div>


        <h3 class="next_bnr">다음은？</h3>
        <div class="bnr_container">
          <div class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/kr/resume/static/renew_img/mailbuy_sale20230602.png" alt="ヤギの宅配便">
              <div class="bnr_txt">
                <a href="#" @click="$eventHub.$emit('goto_basic')">
                  <p>다른 회사에도 보낼려면 나에게 맡겨 메~에~</p>
                  <h3>야기택배<span>이용하기</span></h3>
                </a>
              </div>
            </div>
          </div>
          <div class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/kr/resume/static/renew_img/print.png" alt="コンビニプリント">
              <div class="bnr_txt">
                <a :href="rirekishoOutputUrl">
                  <p>면접에 이력서가 필요해?인쇄해! 메에~</p>
                  <h3>편의점프린터<span>이용하기</span></h3>
                </a>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>

    <div class="preview-viewer tab-content" :style="previewLabelViewerCss" v-show="currentCardId == 'basic'">
      <component v-bind:is="label_preview" ref="previewLabelFormat" :id-prefix="''" :format-data="formatData"
        :format-id="formatId" :basic-data="basicData" :preview-scale="previewScale / 1.3"
        :current-card-id="currentCardId"></component>
    </div>
    <div class="preview-viewer tab-content" :style="previewLetterViewerCss" v-show="currentCardId == 'letter'">
      <component v-bind:is="letter_preview" ref="previewLetterFormat" :id-prefix="''" :format-data="formatLetterData"
        :format-id="formatId" :basic-data="basicData" :preview-scale="previewScale" :current-card-id="currentCardId">
      </component>
    </div>
    <div class="preview-viewer tab-content" :style="previewRirekishoViewerCss" v-show="currentCardId == 'rirekisho'">
      <component v-bind:is="rirekisho_preview" ref="previewRirekishoFormat" :id-prefix="''"
        :format-data="formatRirekishoData" :format-id="formatId" :basic-data="basicData" :preview-scale="previewScale"
        :current-card-id="currentCardId"></component>
    </div>
    <div class="preview-viewer tab-content" :style="previewKeirekishoViewerCss" v-show="currentCardId == 'keirekisho'">
      <component v-bind:is="keirekisho_preview" ref="previewKeirekishoFormat" :id-prefix="''"
        :format-data="formatKeirekishoData" :format-id="formatId" :basic-data="basicData" :preview-scale="previewScale"
        :current-card-id="currentCardId"></component>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.terms_link {
  text-align: right;
  margin: 10px 0;
}

.terms_link_deco {
  color: #E3165C;
  text-decoration: underline;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

.card-header2 {
  border-bottom: 1px solid #f8f8f8;
  padding-bottom: 15px;
  margin-bottom: 20px;
}

.h3 {
  padding-left: 10px;
  border-left: 4px solid #0F9934;
}

.fix {
  margin-left: 20px;
}

.fix1:before {
  content: "\e5df";
  color: #004d40;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 0 30px 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}

.edit_btn {
  text-align: center;
  margin: 5px auto 15px;
}

.edit_btn a {
  color: #fff;
}

.edit_btn_link {
  display: inline-block;
  background: #004D40;
  padding: 8px 30px;
  border-radius: 20px;
  color: #fff;
  font-weight: bold;
  margin-left: 0;
}
</style>
<script>
import HistoryItem from './RirekishoParts/HistoryItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginForms'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import NewRirekishoPreview from '@/components/formats/NewRirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LetterPreview from '@/components/formats/LetterPreview'
import LabelPreview from '@/components/formats/LabelPreview'

import { StripeElementCard } from '@vue-stripe/vue-stripe'

// 書式1枚の高さ
const DOC_PAPER_WIDTH_PX = 794

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'QuickmailBuy',
  props: {
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms,
    StripeElementCard
  },
  data: function () {
    return {
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      basicData: {},
      addressData: {},
      saveName: 'quickmail',
      formatId: 'rirekisho_job_change',
      rirekisho_preview: RirekishoPreview,
      keirekisho_preview: ShokurekishoPreview,
      letter_preview: LetterPreview,
      label_preview: LabelPreview,
      formatRirekishoData: {},
      formatKeirekishoData: {},
      formatLetterData: {},
      addressDataStaffName: "",
      rirekishoUrl: '/format/rirekisho_job_change/edit/profile',
      rirekishoOutputUrl: '/format/rirekisho_job_change/edit/output',
      activeHistoryItem: '',
      rirekishoFormatName: '이직용 이력서(JIS규격)',
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      letterInnerHtml: '',
      rirekishoInnerHtml: '',
      keirekishoInnerHtml: '',
      previewHtml: '',
      previewDialogVisible: true,
      previewScale: 1,
      previewRirekishoViewerCss: {},
      previewKeirekishoViewerCss: {},
      previewLetterViewerCss: {},
      previewLabelViewerCss: {},
      previewTabActive: 'previewFormat',
      isNew: false,
      textareaMinRows: 3,
      isValidStaffname: false,
      isNoneStaffname: false,
      downloadActiveCollapses: ['postcard'],
      formatListOptions: [],
      gradeYearOptions: [
        {
          value: '23',
          label: '23년졸'
        },
        {
          value: '24',
          label: '24년졸'
        },
        {
          value: '99',
          label: '기타'
        }
      ],
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagish고딕'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish명조'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: '도트고딕16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagish고딕'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish명조'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: '도트고딕16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
    }
  },
  computed: {
  },
  methods: {
    tokenCreated(token) {
      const app = this
      app.$eventHub.$emit('loading_on')
      this.token = token.id
      if (this.formatData.addressData_isKeirekisho) {
        if (app.formatLetterData.resumeSummary) {
          if (app.formatLetterData.resumeSummary.indexOf('職務経歴書') < 0 &&
            app.formatLetterData.resumeSummary.indexOf('経歴書') < 0) {
            app.$message({
              message: '송장 동봉서류에 경력기술서 기재가 없습니다.확인을 부탁합니다。',
              type: 'error'
            })
            app.$eventHub.$emit('payment_result', 'error')
            return
          } else {
            console.error('no problem')
          }
        } else {
          app.$message({
            message: '송장 동봉서류에 경력기술서 기재가 없습니다.확인을 부탁합니다。',
            type: 'error'
          })
          app.$eventHub.$emit('payment_result', 'error')
          return
        }
      } else {
        if (app.formatLetterData.resumeSummary) {
          if (app.formatLetterData.resumeSummary.indexOf('경력기술서') < 0 &&
            app.formatLetterData.resumeSummary.indexOf('이력서') < 0) {
            console.error('no problem')
          } else {
            app.$message({
              message: '송장 동봉서류에 직무경력서 기재 되어 있습니다.확인을 부탁합니다.',
              type: 'error'
            })
            app.$eventHub.$emit('payment_result', 'error')
            return
          }
        }
      }
      if (this.letterInnerHtml == '') {
        this.setLetterInnerHtml()
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('quickmail_post', this.formatData.addressData_postNumber)
      formData.append('quickmail_address1', this.formatData.addressData_address1)
      formData.append('quickmail_address2', this.getInputValue(this.formatData.addressData_address2))
      formData.append('quickmail_companyname', this.formatData.addressData_companyName)
      formData.append('quickmail_staffname', this.addressDataStaffName)
      formData.append('rirekisho_html', this.rirekishoInnerHtml)
      formData.append('keirekisho_html', this.keirekishoInnerHtml)
      formData.append('letter_html', this.letterInnerHtml)
      formData.append('letter_flag', this.formatData.addressData_isLetter)
      formData.append('keirekisho_flag', this.formatData.addressData_isKeirekisho ? '1' : '0')
      formData.append('format_id', this.formatData.selFormat)
      formData.append('font_name', this.formatData.selFontStyle4DB)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('from_post', this.formatData.from_post)
      formData.append('from_address1', this.formatData.from_address1)
      formData.append('from_address2', this.getInputValue(this.formatData.from_address2))
      formData.append('from_name', this.formatData.from_name)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'c')

      const _tempHtml = this.$refs.previewLetterFormat.$el.innerHTML
        + this.$refs.previewRirekishoFormat.$el.innerHTML
        + this.$refs.previewKeirekishoFormat.$el.innerHTML
      formData.append('all_html', _tempHtml)

      this.$axios
        .post(this.$varuna.endPoints.paymentQuickmail, formData, { timeout: 60000 })
        .then(function (response) {
          if (response.data['status'] == 'success') {
            app.$message({
              message: '구입을 완료 하였습니다.',
              type: 'success'
            })
            app.$eventHub.$emit('payment_result', 'success')
          } else {
            app.$message({
              message: '결제를 실패하였습니다.',
              type: 'error'
            })
            app.$eventHub.$emit('payment_result', 'error')
          }
        })
        .catch(function (error) {
          app.$message({
            message: '결제를 실패하였습니다.',
            type: 'error'
          })
          app.$eventHub.$emit('payment_result', 'error')
        }).finally(function () {
        })
    },
    selectedPostnumber() {
      if (String(this.formatData.addressData_postNumber).length === 7) {
        this.setAddressFromZip(this.formatData.addressData_postNumber)
      }
    },
    getInputValue: function (inputvalue) {
      return inputvalue ? inputvalue : ''
    },
    setAddressFromZip: function (postNumber) {
      const app = this
      const callback = function (data) {
        app.$refs.address1.value = data.kanji
        app.formatData.addressData_address1 = data.kanji
      }
      this.$formLib.addressFromZip(postNumber, callback)
    },
    testFunction: function (str) {
      console.error("testFunction:" + str)
      this.$eventHub.$emit('payment_result', '8989')
    },
    previewScrollTo: function (id) {
      if (!id) {
        return
      }
      this.$nextTick(function () {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'center'
          })
        }
      })
    },
    setPreviewScale: function () {
      let viewerRef = this.$refs.mainViewer
      this.$nextTick(function () {
        const clientWidth = this.$refs.mainViewer.clientWidth
        this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      const rirekishoheight = this.$refs.previewRirekishoFormat.$refs.previewMain.getBoundingClientRect().height
      const keirekishoheight = this.$refs.previewKeirekishoFormat.$refs.previewMain.getBoundingClientRect().height
      const letterheight = this.$refs.previewLetterFormat.$refs.previewMain.getBoundingClientRect().height
      const labelheight = this.$refs.previewLabelFormat.$refs.previewMain.getBoundingClientRect().height
      this.previewRirekishoViewerCss = {
        height: rirekishoheight + 30 + 'px'
      }
      this.previewKeirekishoViewerCss = {
        height: keirekishoheight + 30 + 'px'
      }
      this.previewLetterViewerCss = {
        height: letterheight + 'px'
      }
      this.previewLabelViewerCss = {
        height: labelheight + 'px'
      }
    },
    setLetterInnerHtml: function () {
      this.letterInnerHtml = this.$refs.previewLetterFormat.$el.innerHTML
    },
    setRirekishoInnerHtml: function () {
      this.rirekishoInnerHtml = this.$refs.previewRirekishoFormat.$el.innerHTML
    },
    setKeirekishoInnerHtml: function () {
      this.keirekishoInnerHtml = this.$refs.previewKeirekishoFormat.$el.innerHTML
    },
    setCheckLetter: function () {
      if (this.formatLetterData.createDate) {
        this.formatData.addressData_isLetter = '1'
      } else {
        this.formatData.addressData_isLetter = '0'
      }
    },
    setAddressDataStaffName: function () {
      if (!this.formatData.addressData_staffName) {
        this.isNoneStaffname = true
        this.addressDataStaffName = '담당자'
      } else {
        this.addressDataStaffName = this.formatData.addressData_staffName
      }
    },
    showPreview: function () {
      this.previewDialogVisible = true
      this.previewTabActive = 'previewFormat'
      this.setPreviewScale()
      this.$nextTick(function () {
        this.previewScrollTo(this.currentCardPreviewJumpId)
      })
    },
    selectFormat: function (isMessaege) {
      // console.error(this.$refs.previewRirekishoFormat.$el)
      // console.error(this.$refs.previewRirekishoFormat.$el.innerHTML)
      for (let key in this.$site.formatsIndex) {
        let item = this.$site.formatsIndex[key]
        if (item.id == this.formatData.selFormat) {
          this.rirekisho_preview = item.components.preview
          this.formatId = item.id
          this.formatData.rirekishoFormatName = item.title
          if (!isMessaege) {
            this.$message({
              message: this.formatData.rirekishoFormatName + '으로 이력서 포맷을 변경하였습니다.미리보기를 확인 해주세요',
              type: 'success'
            })
          }
          this.rirekishoUrl = '/format/' + this.formatId + '/edit/profile'
          this.rirekishoOutputUrl = '/format/' + this.formatId + '/edit/output'
        }
      }
      this.$nextTick(function () {
        this.$refs.previewRirekishoFormat.checkValid()
        this.$nextTick(function () {
          this.setRirekishoInnerHtml()
        })
      })
    },
    selectFont: function () {
      const app = this
      this.formatData.selFontStyle = this.formatData.selFont
      this.formatData.selFontStyle4DB = this.formatData.selFont

      for (const label_name in this.fontOptions) {
        if (this.fontNames[label_name].value == this.formatData.selFont) {
          this.formatData.selectedFontName = '선택한폰트（' + this.fontNames[label_name].label + '）'
          this.formatData.selFontStyle4DB = this.fontNames[label_name].label
        }
      }
    },
    cleanUp: function (name, value) {
      if (name === 'postNumber') {
        value = value.replace('-', '')
        value = this.$formLib.zenToHanNumber(value)
        return String(value)
      }
    },
  },
  watch: {
    'formatData.addressData_postNumberX': function (newValue, oldValue) {
      console.error('formatData.addressData_postNumber')
      // skip first load
      if (!oldValue) {
        return
      }
      const postNumber = this.cleanUp('postNumber', String(newValue))
      if (String(postNumber).length === 7) {
        this.setAddressFromZip(postNumber)
      }
    },
    'formatData.addressData_staffName': function (newValue, oldValue) {
      if (newValue.indexOf('님') >= 0 || newValue.indexOf('분') >= 0) {
        this.isValidStaffname = true
      } else {
        this.isValidStaffname = false
      }
    }
  },
  mounted: function () {
  },
  beforeMount: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      if (key === 'basicData') {
        app.basicData = value
        app.formatData.from_name = app.basicData.lastName + ' ' + app.basicData.firstName
        app.formatData.from_post = app.basicData.postNumber
        app.formatData.from_address1 = app.basicData.address1
        app.formatData.from_address2 = app.basicData.address2
      }
      if (key === 'format_rirekisho') {
        app.formatRirekishoData = value
        if (value.selFormat) {
          app.selectFormat(true)
        }
      }
      if (key === 'format_shokumukeirekisho') {
        app.formatKeirekishoData = value
      }
      if (key === 'format_letter') {
        app.formatLetterData = value
        app.formatData.addressData_companyName = value.company_name
        app.formatData.addressData_staffName = value.staff_name
      }
      if (key === 'recentEdit') {
        if (value.FormatId == 'letter' || value.FormatId == 'shokumukeirekisho') {
          app.selectFormat(true)
        } else {
          app.formatData.selFormat = value.FormatId
          app.selectFormat(true)
        }
      }
    }, function (err) { })
    let idx = 0
    for (let key in this.$site.formatsIndex) {
      let item = this.$site.formatsIndex[key]
      if (item.id != 'letter' && item.id != 'shokumukeirekisho') {
        this.formatListOptions[idx] = {
          value: item.id,
          label: item.title
        }
        idx++
      }
    }
    this.showPreview()
  },
  destroyed: function () {
  }
}
</script>
